module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/board-b54f064c27769322d455f30d4a2a498e.png";